import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import {
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
    NativeDateAdapter,
    provideNativeDateAdapter,
} from '@angular/material/core';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { NgOptimizedImage } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { appRoutes } from 'app/app.routes';
import { clubConfig } from './../config/club.config';
import { environment } from 'environments/environment';
import localeFr from '@angular/common/locales/fr';
import { mockApiServices } from 'app/mock-api';
import { parrainConfig } from 'config/parrain.config';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideFuse } from '@fuse';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { registerLocaleData } from '@angular/common';
import { subdomainInterceptor } from './_interceptors/subdomain.interceptor';

registerLocaleData(localeFr);


const config: SocketIoConfig = {
    url: environment.apiUrlSocket,
    options: {
        transports: ['websocket'],
    },
};

const calendarConfig = {
    provide: DateAdapter,
    useFactory: adapterFactory,
};

//**  Recupere les infos du club en fonction du sous-domaine **/
// const subDomain = window.location.host.split('.')[0];
// const club = clubConfig.find((club) => club.subDomain.id === subDomain);

const club = clubConfig.find((club) => club.id);
const parrain = parrainConfig.find((parrain) => parrain.id);

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideNativeDateAdapter(),
        provideHttpClient(
            withInterceptors([subdomainInterceptor])
        ),
        provideRouter(
            appRoutes,
             // withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: NativeDateAdapter,
        },

        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
        {provide: LOCALE_ID, useValue: 'fr-FR' },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco(),

        // Fuse
        provideAuth(),
        provideIcons(),
        NgOptimizedImage,

        provideFuse({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            fuse: {
                layout: 'dense',
                scheme: 'light',
                screens: {
                    sm: '640px',
                    md: '768px',
                    lg: '1024px',
                    xl: '1280px',
                },
                theme: 'theme-meyrin-fc',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-meyrin-fc',
                        name: 'meyrin-fc',
                    },
                ],
                club: { ...club },
                parrain: { ...parrain },
            },
        }),
        importProvidersFrom(SocketIoModule.forRoot(config)),
        importProvidersFrom(CalendarModule.forRoot(calendarConfig)),
        importProvidersFrom(QuillModule.forRoot())
    ],
};
